document.addEventListener("DOMContentLoaded", function() {

	document.addEventListener('click', function (event) {

		//if the clicked element is a play/pause button
		if (event.target.classList.contains('special-offer-banner-trigger')) {
			event.preventDefault();
			event.target.parentNode.parentNode.classList.toggle('active')
		}
	});
}); 